<template>
  <div>
    <revision-history-panel
      v-if="show"
      :revisionHistories="currentRevisionHistories"
      :branches="branches"
      :selectedBranch="currentBranchId"
      :selectedRevision="currentRevisionHistoryId"
      :onClickRevisionHistory="clickRevisionHistory"
      :onClickBranch="clickBranch"
      :currentAudience="currentAudience"
      :createNewBranch="createNewBranchPopover"
      :heightOfRevisions="heightOfRevisions"
      :heightOfBranches="heightOfBranches"
      :deleteBranch="deleteBranch"
    >
    </revision-history-panel>
    <div class='missing_history_message' v-else>No revision history</div>
  </div>
</template>

<script>
import RevisionHistoryPanel from './RevisionHistoryPanel'
import {PopoverFactory, Forms} from '@/components/common/popover'
import {
  SET_CURRENT_MOVE,
  CREATE_NEW_BRANCH,
  SET_CURRENT_BRANCH,
  DELETE_BRANCH
} from '@/appLogic/revisionHistory/store/actions'

export default {
  components: {
    RevisionHistoryPanel
  },
  props: {
    onSetCurrentMove: {
      type: Function,
      default: () => {}
    },
    heightOfBranches: {
      type: Number,
      default: 300
    },
    heightOfRevisions: {
      type: Number,
      default: 300
    }
  },
  data: () => {
    return {
      createBranchPopover: null
    }
  },
  computed: {
    show () {
      return this.branches.length > 0 && this.currentRevisionHistories.length > 0
    },
    currentBranch () {
      return this.$store.getters.revisionHistoryCurrentBranch
    },
    currentBranchId () {
      return this.currentBranch ? this.currentBranch.id : null
    },
    currentRevision () {
      return this.$store.getters.revisionHistoryCurrentMove
    },
    currentRevisionHistoryId () {
      return this.currentRevision ? this.currentRevision.id : null
    },
    currentRevisionHistories () {
      return this.currentBranch ? this.currentBranch.histories : []
    },
    branches () {
      return this.$store.getters.revisionHistoryBranches
    },
    currentAudience () {
      return this.$store.getters.audienceSize ? this.$store.getters.audienceSize : 0
    }
  },
  methods: {
    clickRevisionHistory (rh) {
      this.$store.dispatch(SET_CURRENT_MOVE, rh)
      this.onSetCurrentMove(rh)
    },
    clickBranch (branch) {
      this.$store.dispatch(SET_CURRENT_BRANCH, branch)
      .then(revision => {
        this.onSetCurrentMove(revision)
      })
    },
    createNewBranch (label) {
      this.$store.dispatch(CREATE_NEW_BRANCH, {
        label,
        targetId: this.$store.getters.currentTarget.id,
        audience: this.currentAudience
      })
    },
    createNewBranchPopover (e) {
      const popoverIsDestroyed = this.createBranchPopover ? this.createBranchPopover._isDestroyed : true
      if (popoverIsDestroyed) {
        this.createBranchPopover = PopoverFactory.createCustomPopover({
          direction: 'bottom',
          parent: e.currentTarget,
          colorTheme: 'black',
          popover: Forms.InputForm,
          onSubmit: this.createNewBranch,
          formLabel: 'Version Label'
        })
      }
    },
    deleteBranch (b) {
      this.$store.dispatch(DELETE_BRANCH, b)
    }
  }
}
</script>

<style>
.missing_history_message {
  padding: 1em;
  font-size: 1.25em;
}
</style>



// WEBPACK FOOTER //
// VuexRevisionHistoryPanel.vue?2ff6ed7e